import camelCase from "lodash/camelCase";
import { ModuleTree } from "vuex";
import { RootState } from "../types";

const requireModule = require.context(
  ".",
  true,
  /^\.\/([a-zA-Z][a-zA-Z0-9_-]+)\/index\.ts$/
);

console.log("requireModule", requireModule);

console.log("requireModule", requireModule.keys());
const modules: ModuleTree<RootState> = {};
const modulesRegex = /^\.\/([a-zA-Z][a-zA-Z0-9_-]+)\/index\.ts$/;

requireModule.keys().forEach((filename) => {
  console.log("modules require", filename);
  const matches = modulesRegex.exec(filename);

  if (matches === null) {
    return;
  }

  const moduleName = camelCase(matches[1]);
  modules[moduleName] = {
    namespaced: true,
    ...requireModule(filename).default,
  };
});

export default modules;
